// THE WALLET SHEET, SEEN FROM OUR SIDE (17 Oct 2026). The Express Checkout
// Element tells us when its button is tapped (`click`) and when the Apple Pay
// or Google Pay sheet is dismissed (`cancel`); until now neither was recorded,
// so a tap that opened the sheet and was then cancelled left no trace
// (booking health check 17 Oct: a week with no iPhone payment and no way to
// see why). wallet_payment_started still fires only on `confirm`.
//
// Kept out of one-checkout.js so it runs under node --test without Stripe.
import { walletMethodOf } from './checkout-mode.js'

// track: { opened(props), cancelled(props) }, the AnalyticsService calls.
// now: a clock, for the tests.
export const walletSheetWatch = ({ opened, cancelled, now = () => Date.now() }) => {
  let open = null
  return {
    // The click was resolved: the sheet is opening.
    opened (expressPaymentType) {
      open = { method: walletMethodOf(expressPaymentType), at: now(), confirmed: false }
      opened({ method: open.method })
    },
    // The payer approved in the sheet. A cancel after this is the sheet
    // being shut on a failed payment, not a change of mind.
    confirmed () {
      if (open) open.confirmed = true
    },
    // The sheet was dismissed. Stripe's cancel event names no wallet, so it
    // is the one the last click opened.
    cancelled () {
      const was = open
      open = null
      cancelled({
        method: was?.method || 'wallet',
        ...(was && { seconds_open: Math.max(0, Math.round((now() - was.at) / 1000)) }),
        after_confirm: !!was?.confirmed
      })
    }
  }
}

// "Now tap Apple Pay": the line above the wallet button once a refused tap's
// missing fields are filled in. Only for the two wallets whose button says
// its name; nothing for Link or an unknown one. No em dashes in copy.
export const walletNudgeText = method =>
  ({ apple_pay: 'Now tap Apple Pay', google_pay: 'Now tap Google Pay' })[walletMethodOf(method)] || null
